import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { ContentPagesPage } from './ui/pages/ContentPagesPage';

export const contentRoutes: RouteObject = {
  path: 'content',
  children: [
    { index: true, element: <Navigate to="/content/pages" replace /> },
    { path: 'pages', element: <ContentPagesPage /> },
    { path: 'pages/:slug', element: <ContentPagesPage /> },
    { path: '*', element: <Navigate to="/content/pages" replace /> },
  ],
};

